import { render } from "./PdfCanvas.vue?vue&type=template&id=2947023e&scoped=true"
import script from "./PdfCanvas.vue?vue&type=script&lang=js"
export * from "./PdfCanvas.vue?vue&type=script&lang=js"

import "./PdfCanvas.vue?vue&type=style&index=0&id=2947023e&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2947023e"]])

export default __exports__